module["exports"] = [
  "کارخانه",
  "و پسران",
  "شرکت با مسئولیت محدود",
  "گروه"
];



//////////////////
// WEBPACK FOOTER
// ./node_modules/faker/lib/locales/fa/company/suffix.js
// module id = 2927
// module chunks = 1610